import React from 'react';
import { default as Form } from 'components/connectedForm';
import * as input from 'components/connectedForm/inputComponents';
import { GenericArrayCard, GenericArrayCardTitle } from '../components/connectedForm/GenericArray';
import HeaderStatus from '../components/connectedForm/HeaderStatus';
import getIn from '../components/connectedForm/utils/getIn';

const DocumentRow = ({ rowData }) => {
  if (rowData == null || rowData.config == null) return null;
  let status;

  if (rowData.config.__typename === 'CommonDocumentGlobalAmend') {
    if (Object.keys(rowData.config).findIndex((key) => key.startsWith('amend') && rowData.config[key]) > 0) {
      status = <HeaderStatus statusStyle={'info'} title={'Amended'} />;
    } else {
      status = <HeaderStatus title={'Not Amended'} />;
    }
  } else if (
    rowData.config.documentsInUse ||
    ((rowData.config.__typename?.toLowerCase?.() === rowData.customerField?.toLowerCase?.() ||
      rowData.config.__typename?.toLowerCase?.() === rowData.supplierField?.toLowerCase?.()) &&
      rowData.config.documentRequired)
  ) {
    status = <HeaderStatus statusStyle={'info'} title={'Enabled'} />;
  } else if (!rowData.alwaysEnabled) {
    status = <HeaderStatus title={'Not in Use'} />;
  }

  return (
    <GenericArrayCard>
      <GenericArrayCardTitle>{rowData.title}</GenericArrayCardTitle>
      <Form.Row>
        <Form.Fieldset cols={1 / 2}>{status}</Form.Fieldset>
      </Form.Row>
    </GenericArrayCard>
  );
};

const AbstractDocumentConfig = ({
  renderRowIsComponent = false,
  forceUpdate,
  documentDefaultList: unfilteredDocumentDefaultList,
  renderDocumentDetails,
}) => {
  const documentDefaultList = unfilteredDocumentDefaultList.filter((configuration) => configuration.config);

  if (documentDefaultList.length === 0) {
    return null;
  }

  return (
    <div style={{ paddingBottom: '50px' }}>
      <Form.Field
        value={documentDefaultList}
        component={input.GenericArray}
        label="Documents"
        renderRow={renderRowIsComponent ? DocumentRow : (rowData) => <DocumentRow rowData={rowData} />}
        renderDetails={renderDocumentDetails}
        enableNewRows={false}
        forceUpdate={forceUpdate}
        renderRowIsComponent={renderRowIsComponent}
        disableHeight={true}
      />
    </div>
  );
};

//Wrapper for standalone forms (Sales|Purchase Document Configuration).
export const AbstractDocumentConfigForm = (props) => {
  const list = props.documentConfigs.map((configuration) => {
    return {
      ...configuration,
      config: getIn(props.values, configuration.field),
    };
  });

  return (
    <Form.FormContainer>
      <Form.Header entityHdr="" noDeleteOption={true} component={Form.HeaderBlock} />
      <Form.Form>
        <AbstractDocumentConfig {...props} documentDefaultList={list} renderRowIsComponent={true} />
      </Form.Form>
    </Form.FormContainer>
  );
};

export default AbstractDocumentConfig;
